import {
  TargetSpecies,
  SignalstarAntibody,
  ImagingRound,
  CreateExperimentReqPayload,
  CreateExperimentResponse,
} from '@cstweb/commercetools-client'
import { computed, ref, useContext } from '@nuxtjs/composition-api'
import { useUserStore } from '~/store'
import { usePanelbuilderConf } from '~/store/panel-builder'

export function usePanelBuilder() {
  const { $signalStar } = useContext()
  const configurationStore = usePanelbuilderConf()
  const userStore = useUserStore()
  const configuration = computed(() => configurationStore.getConfiguration)

  const [isLoading, setLoading] = [ref(false), (value: boolean) => (isLoading.value = value)]
  //   const userStore = useUserStore()

  // Called on step 1
  const initPanelBuilder = (targetSpecies: TargetSpecies) => {
    configurationStore.setTargetSpecies(targetSpecies)
  }

  // Called on step 2
  const selectAntibodies = (antibodies: SignalstarAntibody[]) => {
    configurationStore.setSelectedTargets(antibodies)
  }

  // Called on step 3
  const setImagingRounds = async (imagingRounds: ImagingRound[]) => {
    const sortedImagingRounds = imagingRounds.sort((a, b) => a.round - b.round)
    configurationStore.setImagingRounds(sortedImagingRounds)

    // ..
    if (configurationStore.targetSpecies && configurationStore.selectedTargets && configurationStore.imagingRounds) {
      const payload: CreateExperimentReqPayload = {
        targetSpecies: configurationStore.targetSpecies,
        selectedTargets: configurationStore.selectedTargets,
        imagingRounds: configurationStore.imagingRounds,
        countryCode: userStore.selectedCountry,
        language: userStore.selectedLanguage.toUpperCase(),
      }

      const { data } = await $signalStar.createExperiment(payload)
      const restOfConf = data as CreateExperimentResponse

      configurationStore.updateStore({
        bufferKit: restOfConf.bufferKit,
        ctCustomObjectId: restOfConf.ctObjectId,
        experimentId: restOfConf.experimentId,
        url: restOfConf.url,
      })
    } else {
      console.error('Experiment cannot be created! Configuration is not ready!')
    }
  }

  // Called on step 4 after user downloads PDF or sends an email
  const resetConfiguration = () => {
    configurationStore.resetConfiguration()
  }

  return {
    setLoading,
    isLoading,
    configuration,
    initPanelBuilder,
    resetConfiguration,
    selectAntibodies,
    setImagingRounds,
  }
}
